<script setup>
/* Chip der Altersklasse (U17 / U19). Ohne gültigen Wert wird NICHTS gezeichnet (kein leerer Chip).
   Zwei ruhige Töne aus dem AFH-Farbsystem, ausschließlich über die Variablen aus main.css (hell und dunkel):
   U17 = Sky (im hellen Thema Sky Dark — --green), U19 = Anthrazit (--text, getönt). Kein Orange.
   Kein Punkt und eckigere Form als die Schlagwort-Chips (KeywordChip), damit er als Altersklasse erkennbar ist.
   Absichtlich KEINE Regeln mit .v-theme--light davor: Das war die Ursache der gefüllten Icons (D11). */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { normalizeAgeGroup, ageGroupLabel } from '../domain/ageGroups.js';

const props = defineProps({
  value: { type: String, default: '' },
  /* kleine Fassung für Listenzeilen */
  small: { type: Boolean, default: false },
});

const { t } = useI18n();
const group = computed(() => normalizeAgeGroup(props.value));
const label = computed(() => ageGroupLabel(group.value));
</script>

<template>
  <div
    v-if="group"
    class="age-chip"
    :class="[`age-${group.toLowerCase()}`, { small }]"
    :aria-label="t('ageGroup.chipLabel', { value: label })"
    data-testid="age-group-chip"
  >
    {{ label }}
  </div>
</template>

<style scoped>
.age-chip {
  display: inline-flex;
  align-items: center;
  flex: none;
  box-sizing: border-box;
  height: 26px;
  padding: 0 10px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1;
  white-space: nowrap;
}
.age-chip.small {
  height: 20px;
  padding: 0 7px;
  border-radius: 6px;
  font-size: 11px;
}
.age-chip.age-u17 {
  background: color-mix(in srgb, var(--green) 10%, var(--card));
  border: 1px solid color-mix(in srgb, var(--green) 55%, var(--card));
  color: var(--green);
}
.age-chip.age-u19 {
  background: color-mix(in srgb, var(--text) 12%, var(--card));
  border: 1px solid color-mix(in srgb, var(--text) 38%, var(--card));
  color: var(--text);
}
</style>
